import { defineStore } from 'pinia';

export const useDialogStore = defineStore('dialog', {
    state: () => ({
        openDialog: null,
    }),

    getters: {
        isAnyOpen() {
            return this.openDialog !== null;
        },
    },

    actions: {
        open(name) {
            this.openDialog = name;
        },

        close() {
            this.openDialog = null;
        },

        toggle(name) {
            if (this.openDialog === name) {
                this.close();
            } else {
                this.open(name);
            }
        },

        isOpen(name) {
            return this.openDialog === name;
        },
    },
});
